"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.storage = exports.PersistGate = exports.setStateValue = exports.dynamicStateReducer = void 0;
// import {
//   PersistConfig,
//   FLUSH,
//   REHYDRATE,
//   PAUSE,
//   PERSIST,
//   PURGE,
//   REGISTER,
//   persistReducer,
//   persistStore,
// } from 'redux-persist';
var react_1 = require("redux-persist/integration/react");
Object.defineProperty(exports, "PersistGate", { enumerable: true, get: function () { return react_1.PersistGate; } });
// import {
//   PayloadAction,
//   createSlice,
//   configureStore,
//   createAction,
//   combineReducers,
// } from '@reduxjs/toolkit';
// import { useDispatch, useSelector } from 'react-redux';
var storage_1 = __importDefault(require("redux-persist/lib/storage"));
exports.storage = storage_1.default;
__exportStar(require("./Components/ACWrapperContext"), exports);
__exportStar(require("./libraries/ui-builder"), exports);
// Export the Redux functionality
var sampleSlice_1 = require("./redux/slice/sampleSlice");
Object.defineProperty(exports, "dynamicStateReducer", { enumerable: true, get: function () { return __importDefault(sampleSlice_1).default; } });
Object.defineProperty(exports, "setStateValue", { enumerable: true, get: function () { return sampleSlice_1.setStateValue; } });
